export const isFileSizeCorrect = (file: File, maxFileSize) => {
  return file.size <= maxFileSize * 1000000 ? true : false;
};
